import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";

export const store = configureStore({ reducer: { auth: authReducer } });

store.subscribe(() => {
    const { auth } = store.getState();
    if (auth.token) {
        localStorage.setItem("auth", JSON.stringify(auth));
        localStorage.setItem("token", auth.token);
    } else {
        localStorage.clear();      // wipes everything, including old "staff", "accessToken", etc.
        sessionStorage.clear();
    }
});